<template>
    <header>
        <nav class="top-menu-nav">
            <ul class="top-menu">
                <li><router-link :to="{ name: 'home' }">{{ $t('menu_home') }}</router-link></li>
                <li><router-link :to="{ name: 'domain_list' }">{{ $t('menu_domain_list') }}</router-link></li>
                <li><router-link :to="{ name: 'todo_list' }">{{ $t('menu_toto_list') }}</router-link></li>
                <li><router-link :to="{ name: 'file_list' }">{{ $t('menu_file_list') }}</router-link></li>
                <li><span v-on:click="Logout()">{{ $t('menu_logout') }}</span></li>
            </ul>
            <select v-model="selected_lang" v-on:change="changeLang">
                <option value="bg">bg</option>
                <option value="en">en</option>
            </select>
        </nav>
    </header>
</template>

<script>

    import Store from '../store'
    import config from '../config'
    import {bus} from '../main'
    export default {
        name: 'Header',
        components: {
        },
        data:function(){
            return {
                selected_lang:this.$i18n.locale,
            }
        },
        methods:{
            Logout() {
                this.axios.get(config.API_URL+'users/logout').then(response => {
                    response.data;
                    Store.commit('setAuthenticated',false);
                    this.$router.replace({ name: "login" });
                }).catch(error => {
                    bus.$emit('alert-error',error.response.data.message);
                });
            },
            changeLang(){
                this.$i18n.locale = this.selected_lang;
            }
        },
    }
</script>


<style scoped>
    ul.top-menu{
        display: inline;
    }
    .top-menu > li{
        display: inline-block;
        margin: 1px 5px;
    }
    .top-menu > li > a , .top-menu > li > span{
        color: blue;
        text-decoration: none;
        cursor: pointer;
    }

</style>
